import styled from 'styled-components'
import {Container} from '../Common/Common.style'

export const ProjectContainer = styled(Container)`
  background-color:#ecf0f1;
`


// WEBPACK FOOTER //
// ./src/Projects/Projects.style.js